import {NOTES_READING_MODE, NOTES_MODES, ENVIRONMENTS} from '#/notes/components/definitions'

export const initState = () => ({
  noteRecords: [],
  currentNoteRecord: null,
  currentSearch: '',
  currentPagination: null,
  consumerFilters: {},
  userFilters: {},
  userFiltersMetadata: {},
  isFetching: false,
  currentOrdering: null,
  noteTags: [],
  noteTypes: [],
  readingMode: NOTES_READING_MODE.SHORT,
  currentNoteHistory: [],
  currentMode: NOTES_MODES.LIST,
  environment: ENVIRONMENTS.DEFAULT,
  domains: [],
  noteIsDirty: false
})

export default initState
